import React from "react";
import SEO from "../components/seo/SEO";
import HeroSection from "../components/home/HeroSection";
import OfferingsGrid from "../components/home/OfferingsGrid";
import WhyChooseUs from "../components/home/WhyChooseUs";
import ServicesPreview from "../components/home/ServicesPreview";
import Testimonials from "../components/home/Testimonials";
import WhatMakesDifferent from "../components/home/WhatMakesDifferent";
import CTASection from "../components/home/CTASection";

export default function Index() {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Rite Wellness",
    description:
      "Premium concierge healthcare offering 24/7 virtual care, preventive wellness, and personalized medical attention.",
    url: "https://ritewellness.com",
    medicalSpecialty: ["Primary Care", "Preventive Medicine", "Mental Health"]
  };

  return (
    <>
      <SEO
        title="Personalized Concierge Healthcare"
        description="Experience 24/7 virtual healthcare with personal doctors, holistic wellness programs, and preventive care. Join 50,000+ families trusting Rite Wellness."
        canonical="/"
        keywords="concierge healthcare, virtual doctor, 24/7 medical care, preventive wellness, mental health"
        schema={homeSchema}
      />
      <main>
        <HeroSection />
        <OfferingsGrid />
        <WhyChooseUs />
        <ServicesPreview />
        <Testimonials />
        <WhatMakesDifferent />
        <CTASection />
      </main>
    </>
  );
}
